import React,{useEffect,useState,useRef} from 'react';
import CustomModal from './CustomModal';
import { t } from 'i18next';
import {GetUserAvatar} from '../../services/api';

const Avatar = (props)=>{

    const [name,setName]=useState(localStorage.getItem("avatar_name") ? localStorage.getItem("avatar_name") : null);
    const [showModal, setShowModal] = useState(false);
    const [avatarId,setAvatarId] = useState(null);
    const user_public_id = localStorage.getItem("user_public_id") ? localStorage.getItem("user_public_id") : null;
    const aiDemo = props.hostname === "aidemo"


    useEffect(()=>{
       if(user_public_id){
            if(aiDemo){
                setAvatarId(localStorage.getItem("avatar_id"))
            }
            GetUserAvatar(user_public_id)
            .then((response)=>{

                if(response.data.status == "success"){
                    setAvatarId(response.data.avatar_id)
                }
                
            }).catch((error)=>{console.error('Error:', error);})
        }

    },[user_public_id])

    const handleNameChange = (event) => {
        setName(event.target.value);
      };

    const handleCreateAvatar = ()=>{
        localStorage.setItem("avatar_name",name)
      if( props.user_id){
        window.location.href = '/chatbot'
      }else{
       setShowModal(true);
      }
      
    };

    const handleCloseModal = () => {
        setShowModal(false);
        document.body.classList.remove('no-scroll'); // Enable scrolling
    };

    const handleEditAvatar = () =>{
      window.location.href = `/chatbot/${avatarId}`
    }

    return(
     <div id="chatbot" className='categories-bg mb-5 pt-4'>
        <div className='container'>
            <CustomModal user_id={props.user_id} setUserId={props.setUserId} showModal={showModal} handleClose={handleCloseModal} chatbotpage={true} />

            <div className='row container-avatar'>
                <div className='col-md-6'>
                    <img src="/assets/images/avatar_group.png" className='avatar-group-image' />
                </div>
                <div className='col-md-6 d-flex flex-column justify-content-center'>
                    <div className='avenir-heavy create-avatar-title' style={{color:'#FF8319'}}>{t('chatbot.avatartitle')}</div>
                    <div className='pt-2 text-light create-avatar-desc'><small>{t('chatbot.avatardesc')}</small></div>
                    {avatarId ? (
                        <div className='d-flex avatar-form-edit'>
                            <div className='mt-4'>
                                <input
                                    type="text"
                                    value={name}
                                    onChange={handleNameChange}
                                    className="avatar-input-name form-control"
                                    placeholder={t('chatbot.name')}
                                />
                            </div>
                            <div className='d-flex mt-4'>
                                <div>
                                    <button className='btn create-avatar-button avenir-heavy' onClick={handleCreateAvatar}>{t('chatbot.chat')}</button>
                                </div>
                                <div>
                                    <button className='btn create-avatar-button avenir-heavy' onClick={handleEditAvatar}>{t('chatbot.edit')}</button>
                                </div>
                            </div>
                        </div>

                    ):(
                        <div className='d-flex mt-4 avatar-form'>
                            <input
                                type="text"
                                value={name}
                                onChange={handleNameChange}
                                className="avatar-input-name form-control"
                                placeholder={t('chatbot.name')}
                            />
                            <button className='btn create-avatar-button avenir-heavy' onClick={handleCreateAvatar}  disabled={!name}>{t('chatbot.create')}</button>

                        </div>
                    )}
                </div>
            </div>
        </div>
     </div>
    );

};

export default Avatar;